import React from "react";
import { Button } from "@mui/material";

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Davis Ekstrom Bothman",
      position: "CEO, Ecopack",
      image: require("../../Assets/ceo.png"),
    },
    {
      id: 2,
      name: "James Adeola",
      position: "COO, Ecopack",
      image: require("../../Assets/coo.png"),
    },
    {
      id: 3,
      name: "Fela Dokidis",
      position: "CSO, Ecopack",
      image: require("../../Assets/cso.png"),
    },
  ];

  return (
    <div className="bg-gray-50 py-16" id="team" data-aos="fade-up">
      {/* Team Section */}
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <h2 className="text-3xl font-light text-gray-700 text-center mb-12">
          Our Team
        </h2>

        {/* Team Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="bg-[#E1DCB6] rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group p-2 md:p-4"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-48 md:h-64 object-cover group-hover:scale-105 transition-transform duration-300 rounded-xl"
                />
              </div>

              {/* Member Info */}
              <div className="p-4 md:p-6 text-left">
                <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">
                  {member.name}
                </h3>
                <p className="text-sm text-gray-600">{member.position}</p>
              </div>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="flex justify-center mb-16">
          <Button
            variant="contained"
            className="learn-more-button"
            sx={{
              backgroundColor: "rgba(138, 154, 91, 1)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
                color: "rgba(138, 154, 91, 1)",
              },
              borderRadius: "50px",
              padding: "10px 20px",
              fontSize: "16px",
            }}
          >
            View More{" "}
            <img
              src={require("../../Assets/arrow.png")}
              alt="arrow"
              className="ml-2 arrow-icon"
              style={{ width: "5vmin" }}
            />
          </Button>
        </div>
      </div>

      {/* Call to Action Banner */}
      <div className="max-w-6xl mx-auto px-4">
        <div
          className="relative rounded-3xl overflow-hidden shadow-xl"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${require("../../Assets/ecomock.png")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div className="flex flex-col lg:flex-row items-center min-h-[400px]">
            {/* Left Side - Text Content */}
            <div className="flex-1 p-8 lg:p-12 text-white flo">
              <h2 className="text-4xl lg:text-4xl font-bold mb-6 leading-tight">
                Join the
                <br />
                movement to
                <br />
                make the world a<br />
                waste-free world!
              </h2>

              <p className="text-lg mb-8 opacity-90 max-w-md">
                We are a leading recycling company dedicated to transforming how
                Nigeria manages its waste
              </p>

              <div className="flex justify-start mb-16">
                <Button
                  variant="contained"
                  className="learn-more-button"
                  sx={{
                    backgroundColor: "rgba(138, 154, 91, 1)",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      color: "rgba(138, 154, 91, 1)",
                    },
                    borderRadius: "50px",
                    padding: "10px 20px",
                    fontSize: "16px",
                  }}
                >
                  Learn More{" "}
                  <img
                    src={require("../../Assets/arrow.png")}
                    alt="arrow"
                    className="ml-2 arrow-icon"
                    style={{ width: "5vmin" }}
                  />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
